import React from "react";
import { cn } from "../../utils/cn";
import { Loader2 } from "lucide-react";

export const Spinner = ({
  className,
  strokeWidth = "2",
  size = "md",
  ...props
}) => {
  const sizeMap = {
    sm: "w-4 h-4",
    md: "w-7 h-7",
    lg: "w-10 h-10",
    xl: "w-16 h-16",
  };

  return (
    <div className={cn("inline-flex items-center justify-center", className)} {...props}>
      <Loader2
        className={cn(
          "animate-spin text-urb-primary",
          sizeMap[size] || sizeMap.md
        )}
      />
    </div>
  );
};

export const ProgressSpinner = Spinner;
export default Spinner;
